import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import EventCard from 'screens/Rostering/components/EventCard'
import type { RotaEventInstance } from 'screens/Rostering/types'
import styled from 'styled-components'

type AllocatedEventsPopoverProps = {
  children: ReactNode
  events?: RotaEventInstance[]
}

const AllocatedEventsPopover = ({
  children,
  events
}: AllocatedEventsPopoverProps) => {
  const { t } = useTranslation()

  if (!events) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <AllocatedPopover>
          <Text weight="medium" level={2}>
            {t('ALLOCATED_TO')}
          </Text>
          <EventsContainer>
            {events.map((event) => (
              <EventCard
                key={event.id}
                event={
                  event as unknown as Parameters<typeof EventCard>[0]['event']
                }
              />
            ))}
          </EventsContainer>
        </AllocatedPopover>
      }
    >
      {children}
    </Popover>
  )
}

const AllocatedPopover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 4px;
`
const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export default AllocatedEventsPopover
